import { SVGProps } from 'react'

export function GraphIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M21.6699 6.95003C21.0299 4.78003 19.2199 2.97003 17.0499 2.33003C15.3999 1.85003 14.2599 1.89003 13.4699 2.48003C12.5199 3.19003 12.4099 4.47003 12.4099 5.38003V7.87003C12.4099 10.33 13.5299 11.58 15.7299 11.58H18.5999C19.4999 11.58 20.7899 11.47 21.4999 10.52C22.1099 9.74003 22.1599 8.60003 21.6699 6.95003Z'
				fill='currentColor'
			/>
			<path
				d='M18.9099 13.36C18.6499 13.06 18.2699 12.89 17.8799 12.89H14.2999C12.5399 12.89 11.1099 11.46 11.1099 9.70003V6.12003C11.1099 5.73003 10.9399 5.35003 10.6399 5.09003C10.3499 4.83003 9.9499 4.71003 9.5699 4.76003C7.2199 5.06003 5.0599 6.35003 3.6499 8.29003C2.2299 10.24 1.7099 12.62 2.1599 15C2.8099 18.44 5.5599 21.19 9.0099 21.84C9.5599 21.95 10.1099 22 10.6599 22C12.4699 22 14.2199 21.44 15.7099 20.35C17.6499 18.94 18.9399 16.78 19.2399 14.43C19.2899 14.04 19.1699 13.65 18.9099 13.36Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function DollarCircleIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path d='M12.75 15.92H13.4C14.05 15.92 14.59 15.34 14.59 14.64C14.59 13.77 14.28 13.6 13.77 13.42L12.76 13.07V15.92H12.75Z' fill='currentColor' />
			<path
				d='M11.9701 1.89998C6.45007 1.91998 1.98007 6.40998 2.00007 11.93C2.02007 17.45 6.51007 21.92 12.0301 21.9C17.5501 21.88 22.0201 17.39 22.0001 11.87C21.9801 6.34998 17.4901 1.88998 11.9701 1.89998ZM14.2601 12C15.0401 12.27 16.0901 12.85 16.0901 14.64C16.0901 16.18 14.8801 17.42 13.4001 17.42H12.7501V18C12.7501 18.41 12.4101 18.75 12.0001 18.75C11.5901 18.75 11.2501 18.41 11.2501 18V17.42H10.8901C9.25007 17.42 7.92007 16.04 7.92007 14.34C7.92007 13.93 8.26007 13.59 8.67007 13.59C9.08007 13.59 9.42007 13.93 9.42007 14.34C9.42007 15.21 10.0801 15.92 10.8901 15.92H11.2501V12.54L9.74007 12C8.96007 11.73 7.91007 11.15 7.91007 9.35998C7.91007 7.81998 9.12007 6.57998 10.6001 6.57998H11.2501V5.99998C11.2501 5.58998 11.5901 5.24998 12.0001 5.24998C12.4101 5.24998 12.7501 5.58998 12.7501 5.99998V6.57998H13.1101C14.7501 6.57998 16.0801 7.95998 16.0801 9.65998C16.0801 10.07 15.7401 10.41 15.3301 10.41C14.9201 10.41 14.5801 10.07 14.5801 9.65998C14.5801 8.78998 13.9201 8.07998 13.1101 8.07998H12.7501V11.46L14.2601 12Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function GraphUpIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
			<path d='M3 13.5L7.05714 8.1L9.72381 12.6L15 4.5M15 9V4.5L10.7143 6.3' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='bevel' />
		</svg>
	)
}

export function GraphDownIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
			<path d='M3 4.5L7.05714 9.9L9.72381 5.4L15 13.5M15 9V13.5L10.7143 11.7' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='bevel' />
		</svg>
	)
}

export function ShieldTickIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
			<path
				d='M13.9051 3.09L9.7801 1.545C9.3526 1.3875 8.6551 1.3875 8.2276 1.545L4.1026 3.09C3.3076 3.39 2.6626 4.32 2.6626 5.1675V11.2425C2.6626 11.85 3.0601 12.6525 3.5476 13.0125L7.6726 16.095C8.4001 16.6425 9.5926 16.6425 10.3201 16.095L14.4451 13.0125C14.9326 12.645 15.3301 11.85 15.3301 11.2425V5.1675C15.3376 4.32 14.6926 3.39 13.9051 3.09ZM11.6101 7.29L8.3851 10.515C8.2726 10.6275 8.1301 10.68 7.9876 10.68C7.8451 10.68 7.7026 10.6275 7.5901 10.515L6.3901 9.3C6.1726 9.0825 6.1726 8.72251 6.3901 8.505C6.6076 8.2875 6.9676 8.2875 7.1851 8.505L7.9951 9.315L10.8226 6.4875C11.0401 6.27 11.4001 6.27 11.6176 6.4875C11.8351 6.705 11.8351 7.0725 11.6101 7.29Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function MedalStarIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
			<path
				d='M15.9377 13.8525L14.7002 14.145C14.4227 14.2125 14.2052 14.4225 14.1452 14.7L13.8827 15.8025C13.7402 16.4025 12.9752 16.59 12.5777 16.1175L10.3352 13.5375C10.1552 13.3275 10.2527 12.9975 10.5227 12.93C11.8502 12.6075 13.0427 11.865 13.9202 10.8075C14.0627 10.635 14.3177 10.6125 14.4752 10.77L16.1402 12.435C16.7102 13.005 16.5077 13.7175 15.9377 13.8525Z'
				fill='currentColor'
			/>
			<path
				d='M2.02488 13.8525L3.26238 14.145C3.53988 14.2125 3.75738 14.4225 3.81738 14.7L4.07988 15.8025C4.22238 16.4025 4.98738 16.59 5.38488 16.1175L7.62738 13.5375C7.80738 13.3275 7.70988 12.9975 7.43988 12.93C6.11238 12.6075 4.91988 11.865 4.04238 10.8075C3.89988 10.635 3.64488 10.6125 3.48738 10.77L1.82238 12.435C1.25238 13.005 1.45488 13.7175 2.02488 13.8525Z'
				fill='currentColor'
			/>
			<path
				d='M9 1.5C6.0975 1.5 3.75 3.8475 3.75 6.75C3.75 7.8375 4.0725 8.835 4.6275 9.6675C5.4375 10.8675 6.72 11.715 8.2125 11.9325C8.4675 11.9775 8.73 12 9 12C9.27 12 9.5325 11.9775 9.7875 11.9325C11.28 11.715 12.5625 10.8675 13.3725 9.6675C13.9275 8.835 14.25 7.8375 14.25 6.75C14.25 3.8475 11.9025 1.5 9 1.5ZM11.295 6.585L10.6725 7.2075C10.5675 7.3125 10.5075 7.515 10.545 7.665L10.725 8.4375C10.8675 9.045 10.545 9.285 10.005 8.9625L9.255 8.52C9.12 8.4375 8.895 8.4375 8.76 8.52L8.01 8.9625C7.47 9.2775 7.1475 9.045 7.29 8.4375L7.47 7.665C7.5 7.5225 7.4475 7.3125 7.3425 7.2075L6.705 6.585C6.3375 6.2175 6.4575 5.85 6.9675 5.7675L7.77 5.6325C7.905 5.61 8.0625 5.49 8.1225 5.37L8.565 4.485C8.805 4.005 9.195 4.005 9.435 4.485L9.8775 5.37C9.9375 5.49 10.095 5.61 10.2375 5.6325L11.04 5.7675C11.5425 5.85 11.6625 6.2175 11.295 6.585Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function DropArrowIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path d='M18 9.5L12 14.5L6 9.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='bevel' />
		</svg>
	)
}

export function ChevronLeftIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='22' height='22' viewBox='0 0 22 22' fill='none' {...props}>
			<path d='M13.2918 16.5L8.7085 11L13.2918 5.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='bevel' />
		</svg>
	)
}

export function ChevronRightIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='22' height='22' viewBox='0 0 22 22' fill='none' {...props}>
			<path d='M8.7085 16.5L13.2918 11L8.7085 5.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='bevel' />
		</svg>
	)
}
